<template>
  <div>
    <div class="flex flex-row justify-between items-center">
      <div v-if="props.title" class="py-4">
        <h3
          :class="[
            'text-base  leading-6 text-gray-900 dark:text-white',
            thinHeadings ? 'font-normal' : 'font-semibold',
          ]"
        >
          {{ props.title }}
        </h3>
        <p v-if="props.subtitle" class="mt-2 text-sm text-gray-700">
          {{ props.subtitle }}
        </p>
      </div>
      <slot name="button"> </slot>
    </div>

    <div
      :class="[
        props.clickable ? 'cursor-pointer' : '',
        'rounded-lg shadow ring-1 ring-black dark:ring-slate-700 ring-opacity-5 ',
        props.colorField || 'bg-white dark:bg-slate-900',
      ]"
    >
      <div :class="props.nopadding || props.loading ? '' : 'p-4'">
        <slot v-if="!props.loading"></slot>

        <Spinner v-else />
      </div>
      <div
        v-if="slots.footer"
        class="flex items-center justify-end gap-x-6 border-t border-gray-900/10 p-4"
      >
        <slot name="footer" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useSlots } from "vue";
import Spinner from "./utils/Spinner.vue";

const props = defineProps([
  "title",
  "subtitle",
  "clickable",
  "nopadding",
  "loading",
  "thinHeadings",
  "colorField",
]);

const slots = useSlots();
</script>
